export default __webpack_public_path__ + "static/valeria-69062830504d2e736cd9d688e6344349.jpg";